module.exports = __webpack_public_path__ + "static/media/community.ef20e344.svg";